const FONT_KEY = "lefy_font_level";

export const FONT_MIN = 1;
export const FONT_MAX = 5;
export const FONT_DEFAULT = 3;

const FONT_MAP = {
  1: 14,
  2: 15,
  3: 16,
  4: 18,
  5: 20
};

export function getFontLevel() {
  const raw = parseInt(localStorage.getItem(FONT_KEY) || FONT_DEFAULT, 10);
  if (isNaN(raw)) return FONT_DEFAULT;
  return Math.min(FONT_MAX, Math.max(FONT_MIN, raw));
}

export function setFontLevel(level) {
  const v = Math.min(FONT_MAX, Math.max(FONT_MIN, level));
  localStorage.setItem(FONT_KEY, v);
  applyFontLevel(v);
}

export function applyFontLevel(level) {
  const size = FONT_MAP[level] || FONT_MAP[FONT_DEFAULT];
  document.documentElement.style.fontSize = size + "px";
}

export function initFontLevel() {
  const lvl = getFontLevel();
  applyFontLevel(lvl);
  return lvl;
}